import { Box, FormControlLabel, Typography } from '@mui/material';
import ExtendedLink from '../ExtendedLink/ExtendedLink';
import React from 'react';
import MuiCheckbox, { MuiCheckboxProps } from '../../mui/MuiCheckbox';
import { Spinner } from '../Spinner';
import { gql } from '@apollo/client';
import { useAutomatedNotificationsToggle_GetGlobalVariablesQuery } from '#types';
import styles from './AutomatedNotificationsToggle.module.scss';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getGlobalVariablesQuery = gql`
	query AutomatedNotificationsToggle_getGlobalVariables {
		getGlobalVariables {
			AutomatedNotificationsSupportUrl
		}
	}
`;

export type AutomatedNotificationsToggleProps = Pick<
	MuiCheckboxProps,
	'checked' | 'onChange' | 'disabled'
> & { loading?: boolean };

export const AutomatedNotificationsToggle: React.FC<
	AutomatedNotificationsToggleProps
> = ( props ) => {
	const { loading, ...rest } = props;
	const { data: globalVariableData, loading: globalVariableLoading } =
		useAutomatedNotificationsToggle_GetGlobalVariablesQuery();
	const href =
		globalVariableData?.getGlobalVariables.AutomatedNotificationsSupportUrl;
	return (
		<FormControlLabel
			disabled={ props.disabled }
			control={
				loading ? (
					<Box className={ styles.spinner }>
						<Spinner size={ 20 } />
					</Box>
				) : (
					<MuiCheckbox
						{ ...rest }
						slotProps={ { input: { 'data-cy': 'automatedReminders' } } }
					/>
				)
			}
			label={
				<Typography color={ props.disabled ? 'textDisabled' : undefined }>
					Send{ ' ' }
					<ExtendedLink
						target='_blank'
						href={ href }
						rel='noreferrer'
						loading={ globalVariableLoading }
					>
						email notifications
					</ExtendedLink>{ ' ' }
					to customers
				</Typography>
			}
		/>
	);
};
